import * as React from 'react';
import safeLog from '@alife/bc-safe-log';

interface SliderState {
  curIndex: number,
  scale: number,
  enableBigger: boolean,
  enableSmaller: boolean,
  dataSource: any[],
}
interface SliderProps {
  onChange?: (curIndex: number) => void,
  dataSource: any[],
  slickGoTo?: number,
  showArrow?: boolean,
  // 外层容器额外传进来的高度参数
  containerHeight?: string,
  enableScale?: boolean
}

const ZOOM_STEP = 0.2;
const ZOOM_MAX = 2;
const ZOOM_MIN = 1;
export default class Slider extends React.Component<SliderProps, SliderState> {
  constructor(props) {
    super(props);
    this.state = {
      curIndex: props.slickGoTo || 0,
      scale: 1,
      enableBigger: true,
      enableSmaller: true,
      dataSource: props.dataSource
    }
  }

  componentWillReceiveProps(nextProps) {
    const { slickGoTo, dataSource } = nextProps;
    this.setState({
      ...this.state,
      curIndex: slickGoTo,
      scale: 1,
      enableBigger: true,
      enableSmaller: false,
      dataSource,
    });
  }

  leftClick = () => {
    const curIndex = this.state.curIndex === 0 ? this.state.dataSource.length - 1 : this.state.curIndex - 1;
    this.setState({
      ...this.state,
      curIndex,
      scale: 1,
      enableBigger: true,
      enableSmaller: true,
    });
    this.props.onChange && this.props.onChange(curIndex);
    safeLog('/sc.details.commonLogs', 'CLK', 'info=&action=mainImageDialogArrowClick');
  }

  rightClick = () => {
    const curIndex = this.state.curIndex === this.state.dataSource.length - 1 ? 0 : this.state.curIndex + 1;
    this.setState({
      ...this.state,
      curIndex,
      scale: 1,
      enableBigger: true,
      enableSmaller: true,
    });
    this.props.onChange && this.props.onChange(curIndex);
    safeLog('/sc.details.commonLogs', 'CLK', 'info=&action=mainImageDialogArrowClick');
  }
  
  bigger = () => {
    safeLog('/sc.details.commonLogs', 'CLK', `info=&action=mainImageDialogBigger`);
    const newScale = Number((this.state.scale + ZOOM_STEP).toFixed(1));
    this.setState({
      ...this.state,
      scale: newScale >= ZOOM_MAX ? ZOOM_MAX : newScale,
      enableBigger: newScale < ZOOM_MAX,
      enableSmaller: true,
    }, () => {
      this.setState({
        ...this.state,
        enableBigger: this.state.scale < ZOOM_MAX,
      })
    })
  }

  smaller = () => {
    safeLog('/sc.details.commonLogs', 'CLK', `info=&action=mainImageDialogSmaller`);
    const newScale = Number((this.state.scale - ZOOM_STEP).toFixed(1));
    this.setState({
      ...this.state,
      scale: newScale <= ZOOM_MIN ? ZOOM_MIN : newScale,
      enableBigger: true,
    }, () => {
      this.setState({
        ...this.state,
        enableSmaller: this.state.scale > ZOOM_MIN,
      })
    })
  }
  render() {
    const cldren = this.props.children;
    const showEle = cldren[this.state.curIndex];
    if (!showEle) {
      return null
    }
    return (
      <div className="image-slider">
        { this.props.showArrow && <div className="left-arrow" onClick={this.leftClick}><img src="https://img.alicdn.com/tfs/TB1HzaYoypE_u4jSZKbXXbCUVXa-28-44.svg" alt="left-btn" /></div>}
        { this.props.showArrow && <div className="right-arrow" onClick={this.rightClick}><img src="https://img.alicdn.com/tfs/TB1HzaYoypE_u4jSZKbXXbCUVXa-28-44.svg" alt="right-btn" /></div>}
        {
          showEle.props.type === 'image' ? React.cloneElement(
            showEle,
            {
              style: {
                transform: `scale(${this.state.scale})`,
                transition: 'all 0.3s',
                width: '100%',
                objectFit: 'contain',
                maxHeight: '90vh'
              },
            }
          ) : showEle
        }
        {
          (this.props.enableScale && showEle.props.type === 'image') && (
            <div className="slide-zoom-container">
              <div className="slide-zoom">
                { this.state.enableBigger && <img className="bigger-btn" src="https://img.alicdn.com/tfs/TB1IFvs2xD1gK0jSZFsXXbldVXa-24-24.svg" onClick={this.bigger} /> }
                { !this.state.enableBigger && <img className="bigger-btn" src="https://img.alicdn.com/tfs/TB1IFvs2xD1gK0jSZFsXXbldVXa-24-24.svg" style={{ cursor: 'not-allowed', opacity: 0.3 }} /> }
                { this.state.enableSmaller && <img className="smaller-btn" src="https://img.alicdn.com/tfs/TB1bPMcmZieb18jSZFvXXaI3FXa-24-24.svg" onClick={this.smaller} /> }
                { !this.state.enableSmaller && <img className="smaller-btn" src="https://img.alicdn.com/tfs/TB1bPMcmZieb18jSZFvXXaI3FXa-24-24.svg" style={{ cursor: 'not-allowed', opacity: 0.3 }} /> }
              </div>
            </div>
          )
        }
      </div>
    );
  }
}
